import { render } from "./TemplatePruning.vue?vue&type=template&id=3b2a2930&scoped=true&ts=true"
import script from "./TemplatePruning.vue?vue&type=script&lang=ts"
export * from "./TemplatePruning.vue?vue&type=script&lang=ts"

import "./TemplatePruning.vue?vue&type=style&index=0&id=3b2a2930&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a2930"]])

export default __exports__